const { permissions } = require('../../constants/permissions');

require('./targets.style.scss');

class TargetsController {
    constructor($scope, $filter, $stateParams, $timeout, $element, $log, $rootScope, dialogService, targetsPersistence, utilsService, styleService, notificationService, storageService, iamPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$log = $log;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.dialogService = dialogService;
        this.targetsPersistence = targetsPersistence;
        this.utilsService = utilsService;
        this.notificationService = notificationService;
        this.iamPersistenceService = iamPersistenceService;
        this.storageService = storageService;
        this.configTargetsTable();
        this.donutColorsBase = styleService.getDonutColor('target-details');
        this.classesList = ['circle-policy-1', 'circle-policy-2', 'circle-policy-3', 'circle-policy-others', 'circle-policy-free', 'circle-policy-overflow'];
        this.utilizationSubTitle = this.$filter('translate')('target.subTable.utilization');
        this.graphBackupTitle = this.$filter('translate')('target.subTable.backupTroughput');
        this.graphRestoreTitle = this.$filter('translate')('target.subTable.restoreTroughput');
        this.widgetState = 'app.policies';
        this.isMini = false;


        this.$scope.$on('targets.refresh', () => {
            this.getTargets();
            if (this.shownDetailsIndex === this.selectedTargets[0].uuid) this.showDetails(this.shownDetailsIndex, true);
        });

        this.$scope.$on('sub-changed', () => {
            this.getTargets(true, true, true);
        });
    }

    $onInit() {
        this.filterFlag = 0;
        this.getTargets(true, true, true);
        this.selectedTargets = [];
        this.filterFlag++;

        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.getTargets(true, true, true);
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    configTargetsTable() {
        this.columnConfigs = [
            {
                key: 'name',
                title: this.$filter('translate')('target.table.header.name'),
                width: '27%'
            },
            {
                key: 'location_name',
                title: this.$filter('translate')('target.table.header.location'),
                width: '13%'
            },
            {
                key: 'kind',
                title: this.$filter('translate')('target.table.header.accessTier'),
                width: '12%',
            },
            {
                key: 'status',
                title: this.$filter('translate')('target.table.header.status'),
                width: '10%',
            },
            {
                key: 'sizeLimit',
                title: this.$filter('translate')('target.table.header.sizeLimit'),
                width: '8%'
            },
            {
                key: 'health',
                title: this.$filter('translate')('target.table.header.health'),
                width: '8%',
                class: 'text-center'
            },
            {
                key: 'utilization',
                title: this.$filter('translate')('target.table.header.utilization'),
                width: '11%',
            },
            {
                key: 'isAutoCreated',
                title: this.$filter('translate')('target.table.header.automatic'),
                width: '11%',
                class: 'text-center'
            },
        ];
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('27%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('13%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('14%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('8%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('8%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('8%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('11%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('11%');
        this.$timeout(() => {
            this.grid.tableName = this.grid.tableName + '-' + this.storageService.getUsername();
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName);
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    getTargetsOnCloseDialog(target) {
        this.getTargets(null, null, null, null, target);
    }

    getTargets(firstPage, targetId, firstLoad, clearSelection, savedTarget) {
        this.busy = true;
        if (clearSelection) {
            this.shownDetailsIndex = false;
            this.selectedTargets = [];
        }
        this.targetsPersistence.get(firstPage).then(targets => {
            this.targets = !targets ? [] : targets.map(t => {
                t.created = this.$filter('localizeDate')(t.created, 'shortSec');
                t.sizeLimit = this.utilsService.expressBytes(t.sizeLimit);
                t.utilization = Math.round(t.utilization * 100);
                t.location_name = t.location_name.displayName;
                t.healthTooltip = this.updateTooltip(t);
                t.azurePortalUrl = t.azurePortalUrl;
                return t;
            });
            if (savedTarget) {
                this.selectedTargets = this.targets.filter(t => t.name === savedTarget.targetName);
                if (!this.selectedTargets[0]) {
                    this.shownDetailsIndex = false;
                    return;
                }
                this.selectedTargets[0]._selected = true;
                this.showDetails(this.selectedTargets[0], false);
            } else {
                if (firstLoad && this.targets.length) {
                    this.$timeout(() => {
                        this.targets[0]._selected = true;
                        this.selectedTargets[0] = this.targets[0];
                        this.showDetails(this.selectedTargets[0]);
                    }, 0);
                }
                else if (typeof targetId !== 'undefined' && this.shownDetailsIndex === targetId) {
                    this.showDetails(this.shownDetailsIndex, true);
                }
                else if (this.selectedTargets && this.selectedTargets.length && !savedTarget) {
                    this.$timeout(() => {
                        this.selectedTargets = targets.filter(t => t.uuid === this.selectedTargets[0].uuid);
                        if (!this.selectedTargets[0]) {
                            this.shownDetailsIndex = false;
                            return;
                        }
                        this.selectedTargets[0]._selected = true;
                        this.showDetails(this.selectedTargets[0], true);
                    }, 0);
                }
            }
            this.isMini = false;
            this.busy = false;
        }, err => {
            this.busy = false;
            this.targets = [];
            this.selectedTargets = [];
            this.shownDetailsIndex = false;
        });
    }

    filterRefresh() {
        this.getTargets(true, null, null, true);
        this.filterFlag++;
    }

    del() {
        let selected = this.selectedTargets[0];
        this.dialogService.showYesNo(this.$filter('translate')('target.deleteDialog.text', { name: selected.name }), this.$filter('translate')('target.deleteDialog.title'), this.$filter('translate')('target.deleteDialog.notice'), 'targets-delete')
            .then(result => {
                if (!result) return false;
                return this.targetsPersistence.delete(selected).then(() =>
                    this.getTargets());
            });
    }

    toggleActive() {
        if (this.selectedTargets[0].state === 'ACTIVE') {
            this.dialogService.showYesNo(this.$filter('translate')('target.deactivateDialog.text', { name: this.selectedTargets[0].name }), this.$filter('translate')('target.deactivateDialog.title'), null, 'targets-deactivate')
                .then(result => result ? this.toggleTargetState(this.selectedTargets[0]) : false);
        } else {
            this.toggleTargetState(this.selectedTargets[0]);
        }
    }

    toggleTargetState(selectedTarget) {
        this.targetsPersistence.toggleActive(selectedTarget, selectedTarget.state === 'INACTIVE')
            .then(res => {
                this.notificationService.pop(res.data.message);
                this.getTargets();
            }, err => {
            });
    }

    showDetails(item, onUpdate) {
        // this.selectedTargets[0] = item;
        this.busyTargetDetails = true;
        if (!onUpdate) {
            this.shownDetailsIndex = item._selected ? item.uuid : false;
            this.clearTargetDetails();
        }
        if (!this.shownDetailsIndex) {
            this.selectedTargets = false;
            return;
        }
        if (this.iamPersistenceService.hasPermissions(permissions.TARGET_DETAILS)) {
            this.targetsPersistence.getTarget(this.shownDetailsIndex).then(
                resp => {
                    let data = resp.data.entities[0];
                    this.targetDetailsName = data.name;
                    this.setDetails(data);
                    this.initDonutHighlight();
                },
                err => {
                    this.busyTargetDetails = false;

                    this.$log.error(err);
                }
            );
        } else {
            this.isMini = false;
            this.busyTargetDetails = false;
        }
    }

    setDetails(target) {
        if (!target) return;

        const availableSize = this.utilsService.expressBytes(target.availableSize);
        // SETUP INFO
        this.targetDetails = [
            {
                detail: this.$filter('translate')('target.subTable.detail.uuid.label'),
                value: target.targetUuid,
                icon: 'icon-copy',
                id: 'target-uuid'
            },
            {
                detail: this.$filter('translate')('target.subTable.detail.created.label'),
                value: this.$filter('localizeDate')(target.created, 'shortSec')
            },
            {
                detail: this.$filter('translate')('target.subTable.detail.availableSize.label'),
                value: availableSize ? availableSize : '0',
                class: target.health === 'YELLOW' ? 'status-yellow' : target.health === 'RED' ? 'status-red' : null
            },
            {
                detail: this.$filter('translate')('target.subTable.detail.sizeLimit.label'),
                value: this.utilsService.expressBytes(target.sizeLimit - target.availableSize),
            },
            {
                detail: this.$filter('translate')('target.subTable.detail.avgWrite.label'),
                tooltip: this.$filter('translate')('target.details.averageBackup.tooltip'),
                value: target.averageBackup && target.averageBackup >= 0 ? this.utilsService.expressBytes(this.utilsService.toBytes(target.averageBackup, 'kib'), true) : '0'
            },
            {
                detail: this.$filter('translate')('target.subTable.detail.avgRead.label'),
                tooltip: this.$filter('translate')('target.details.averageRestore.tooltip'),
                value: target.averageRestore && target.averageRestore >= 0 ? this.utilsService.expressBytes(this.utilsService.toBytes(target.averageRestore, 'kib'), true) : '0'
            },
            {
                detail: this.$filter('translate')('target.table.header.subscriptionName'),
                value: target.subscriptionName
            }
        ];

        // SETUP UTILIZATION
        const usedPercentage = Math.round(target.utilization * 100);
        const freePercentage = 100 - usedPercentage;

        this.donutTextColorClass = target.health === 'YELLOW' ? 'status-yellow' : target.health === 'RED' ? 'status-red' : null;
        this.donutColors = ['rgb(0,123,123)', 'rgb(221,221,221)'];
        this.utilizationStatusData = [{
            name: 'Used',
            title: 'Used',
            value: usedPercentage,
            class: this.classesList[0]
        }, {
            name: 'Free',
            title: 'Free',
            value: freePercentage,
            class: this.classesList[4]
        },];
        if (freePercentage < 0) {
            const overflow = -freePercentage;
            this.donutColors = ['rgb(0,123,123)', '#AD3326'];
            this.utilizationStatusData = [{
                name: 'Used',
                title: 'Used',
                value: usedPercentage,
                class: this.classesList[0]
            }, {
                name: 'Overflow',
                title: 'Overflow',
                value: overflow,
                class: this.classesList[5]
            },];
        }
        this.donutData = [usedPercentage, freePercentage];

        // SETUP GRAPHS (backup throughput data and restore throughput data)
        this.prepareGraphs(target);
    }

    prepareGraphs(target) {
        let backupData, backupGraphLength, restoreData, restoreGraphLength;
        this.graphBackup = { graph1: [], graph2: [] };
        this.graphRestore = { graph1: [], graph2: [] };

        // SETUP BACKUP THROUGHPUT DATA
        if (target.writeThroughputList) {
            backupData = _.sortBy(target.writeThroughputList, 'date');
            this.graphBackup.graph1 = this.setGraph(backupData, 'avgOpBwInKBps');
            this.graphBackup.graph2 = this.setGraph(backupData, 'avgSliceBwInKBps');
            //backupGraphLength = this.graphBackup.graph1.length;
        }
        //this.backupTimeUnit = backupGraphLength >= 2 ?  this.getTimeUnit(this.graphBackup.graph1[0].x, this.graphBackup.graph1[backupGraphLength-1].x) : 'minutes';

        // SETUP RESTORE THROUGHPUT DATA
        if (target.readThroughputList) {
            restoreData = _.sortBy(target.readThroughputList, 'date');
            this.graphRestore.graph1 = this.setGraph(restoreData, 'avgOpBwInKBps');
            this.graphRestore.graph2 = this.setGraph(restoreData, 'avgSliceBwInKBps');
            //restoreGraphLength = this.graphRestore.graph1.length;
        }
        //this.restoreTimeUnit = restoreGraphLength >= 2 ?  this.getTimeUnit(this.graphRestore.graph1[0].x, this.graphRestore.graph1[restoreGraphLength-1].x) : 'minutes';
        this.busyTargetDetails = false;

    }

    setGraph(data, key) {
        return data.map(d => {
            return { x: d.date, y: this.utilsService.roundValue(d[key] / 1024 || 0) };
        });
    }

    clearTargetDetails() {
        this.donutData = null;
        this.utilizationStatusData = null;
        this.itemClassesList = [];
        this.graphBackup = null;
        this.graphRestore = null;
    }

    initDonutHighlight() {
        this.$timeout(() => {
            this.itemClassesList.forEach((item, index) => {
                this.$element.find('details-slot div.' + item.split(' ')[0]).hover(
                    () => {
                        this.$timeout(() => {
                            this.highlightedSlice = index;
                        });
                    },
                    () => {
                        this.$timeout(() => {
                            this.highlightedSlice = undefined;
                        });
                    }
                );
            });
        });
    }

    updateTooltip(target) {
        let tooltip = '';
        switch (target.health) {
            case 'GREEN':
                tooltip = this.$filter('translate')('target.tooltip.green');
                break;
            case 'YELLOW':
                if (target.publiclyAccessible === true) {
                    tooltip = !target.testErrorMessage ? this.$filter('translate')('target.tooltip.yellow.pub') : target.testErrorMessage.detailsDescription;
                } else {
                    tooltip = !target.testErrorMessage ? this.$filter('translate')('target.tooltip.yellow') : target.testErrorMessage.detailsDescription;
                }
                break;
            case 'RED':
                if (target.state === "DELETED_FROM_AZURE") {
                    tooltip = !target.testErrorMessage ? this.$filter('translate')('target.tooltip.red.deleted') : target.testErrorMessage.detailsDescription;
                } else if (target.state === "INACCESSIBLE_ON_AZURE") {
                    tooltip = !target.testErrorMessage ? this.$filter('translate')('target.tooltip.red.inaccessible') : target.testErrorMessage.detailsDescription;
                } else {
                    tooltip = !target.testErrorMessage ? this.$filter('translate')('target.tooltip.red') : target.testErrorMessage.detailsDescription;
                }
                break;
            case 'GREY':
                if (target.state === "INACTIVE") {
                    tooltip = !target.testErrorMessage ? this.$filter('translate')('target.tooltip.grey2') : target.testErrorMessage.detailsDescription;
                } else {
                    tooltip = !target.testErrorMessage ? this.$filter('translate')('target.tooltip.grey') : target.testErrorMessage.detailsDescription;
                }
                break;
            default:
                break;
        }
        return tooltip;
    }

    getTimeUnit(date1, date2) {
        let difference = date2 - date1,
            daysDifference, hoursDifference, minutesDifference, secondsDifference;

        daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
        difference -= daysDifference * 1000 * 60 * 60 * 24;
        hoursDifference = Math.floor(difference / 1000 / 60 / 60);
        difference -= hoursDifference * 1000 * 60 * 60;
        minutesDifference = Math.floor(difference / 1000 / 60);
        difference -= minutesDifference * 1000 * 60;
        secondsDifference = Math.floor(difference / 1000);
        return hoursDifference > 0 ? 'hours' : 'minutes';
    }

    openTargetAddDialog() {
        this.isEdit = false;
        this.targetToEdit = null;
        this.showTargetAddEditDialog = true;
    }

    openTargetEditDialog() {
        this.isEdit = true;
        this.targetToEdit = this.selectedTargets[0];
        this.showTargetAddEditDialog = true;
    }

    onExport(type) {
        this.busy = true;
        return this.targetsPersistence[type === 'all' ? 'getAllTargets' : 'get'](type === 'all', { isExport: true }).then(res => {
            return res.map(item => {
                let result = {};
                // console.log(item)
                result['name'] = item.name;
                result['location'] = item.location_name.name;
                result['kind'] = item.kind;
                result['state'] = item.state;
                result['size limit'] = item.sizeLimit;
                result['health'] = item.health;
                result['utilization'] = Math.round(item.utilization * 100) + '%';
                result['automatic'] = item.isAutoCreated;
                return result;
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    isAddTargetDisabled() {
        return !this.hasAddTargetPermissions();

    }

    isUpdateTargetDisabled() {
        return !this.hasUpdateTargetPermissions() ||
            !this.selectedTargets ||
            !this.selectedTargets.length ||
            this.selectedTargets[0].state === 'DELETED_FROM_AZURE' ||
            this.selectedTargets[0].state === 'INACCESSIBLE_ON_AZURE';
    }

    isDeleteTargetDisabled() {
        return !this.hasDeleteTargetPermissions() || !this.selectedTargets || !this.selectedTargets.length;
    }

    isDeactivateTargetDisabled() {
        return !this.hasDeactivateTargetPermissions() || !this.selectedTargets || !this.selectedTargets.length || !this.selectedTargets[0] || this.selectedTargets[0].isAutoCreated;
    }

    isActivateTargetDisabled() {
        return !this.hasActivateTargetPermissions() || !this.selectedTargets || !this.selectedTargets.length || !this.selectedTargets[0] || this.selectedTargets[0].isAutoCreated;
    }

    hasDeleteTargetPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TARGET_DELETE);
    }

    hasActivateTargetPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TARGET_ACTIVATE);
    }

    hasDeactivateTargetPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TARGET_DEACTIVATE);
    }

    hasUpdateTargetPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TARGET_UPDATE);
    }

    hasAddTargetPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TARGET_ADD);
    }

    hasTargetListPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TARGET_LISTING);
    }

    hasTargetDetailsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TARGET_DETAILS);
    }

}

const targetsComponent = {
    controller: TargetsController,
    template: require('./targets.template.html'),
};

TargetsController.$inject = ['$scope', '$filter', '$stateParams', '$timeout', '$element', '$log', '$rootScope', 'dialogService', 'targetsPersistence', 'utilsService', 'styleService', 'notificationService', 'storageService', 'iamPersistenceService'];

module.exports = targetsComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/targets/targets.component.js